import { render, staticRenderFns } from "./Confirm.vue?vue&type=template&id=176d5b15&scoped=true"
import script from "./Confirm.vue?vue&type=script&setup=true&lang=js"
export * from "./Confirm.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Confirm.vue?vue&type=style&index=0&id=176d5b15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176d5b15",
  null
  
)

export default component.exports